// extracted by mini-css-extract-plugin
export var active = "_2r-7";
export var backButton = "_2r-6";
export var clone = "_2r-c";
export var collapseBar = "_2r-g";
export var collapseMode = "_2r-i";
export var dragHandle = "_2r-a";
export var dropdownIcon = "_2r-e";
export var hidden = "_2r-o";
export var iconContainer = "_2r-l";
export var iconSwapper = "_2r-n";
export var navItem = "_2r-4";
export var navItemIcon = "_2r-d";
export var navProfile = "_2r-5";
export var notificationDot = "_2r-m";
export var optionsContainer = "_2r-f";
export var primaryNav = "_2r-0";
export var primaryTab = "_2r-j";
export var secondaryNav = "_2r-1";
export var selected = "_2r-k";
export var settingsNav = "_2r-2";
export var settingsNavItems = "_2r-3";
export var show = "_2r-b";
export var sideNav = "_2r-h";
export var teamItem = "_2r-8";
export var userProfileItem = "_2r-9";